export default "__VITE_ASSET__BVe$31PF__"